import {
  anInsight,
  anInsightComment,
  mockInsightCommentsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const insightCommentsResponse = (comment: string = 'test comment') => {
  return {
    __typename: 'Query',
    insight: {
      comments: [
        anInsightComment({
          id: '1',
          body: comment,
        }),
      ],
    },
  };
};

export const handlers = [
  mockInsightCommentsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insight: anInsight(),
        },
      });
    }
  ),
];
